// extracted by mini-css-extract-plugin
module.exports = {"container":"ElasticSearch__container","suggestions":"ElasticSearch__suggestions","suggestion":"ElasticSearch__suggestion","hover":"ElasticSearch__hover"};